module.exports = __webpack_public_path__ + "img/computer.3a400ebd.png";